/* Pipglen - anonymous play counter (beacon). Sends ONE tiny POST per game page load, on the first keydown anywhere on the page or the first pointer/touch press inside the page's main game section. Body = game slug only. No cookies, no storage, no IDs, no referrer. Skipped on Do Not Track / Global Privacy Control. */
(function(){
'use strict';
var URL_='https://pipglen-plays.pipglen.workers.dev/p';
if(navigator.doNotTrack==='1'||window.doNotTrack==='1'||navigator.msDoNotTrack==='1'||navigator.globalPrivacyControl===true)return;
// Local-only region check (no network, nothing sent or stored): do not count visitors whose device time zone is in Europe/UK/EEA/CH.
try{var tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'';
if(!tz||/^(Europe|Arctic)\//.test(tz)||/^(Atlantic\/(Azores|Madeira|Canary|Reykjavik|Faroe|Faeroe)|Africa\/Ceuta|Asia\/(Nicosia|Famagusta)|Indian\/(Reunion|Mayotte)|America\/(Martinique|Guadeloupe|Cayenne|Marigot|St_Martin|St_Barthelemy))$/.test(tz))return}catch(e){return}
var m=location.pathname.match(/^\/pages\/([a-z0-9-]+)\/?$/);if(!m)return;
var og=document.querySelector('meta[property="og:image"]'),u=og&&og.content||'';
var g=u.match(/(?:pl-og-|pipglen-og-)([a-z0-9-]+?)(?:-v\d+)?\.jpg/);
if(!g||g[1]!==m[1])return; /* hubs/info pages have no matching game og image: not counted */
var slug=m[1],done=false,AREA='.pls-stage,.pls-box,.ngx-stage,[data-ng-own-stage],[data-ng],canvas',GAME=/__(game|main)$/;
/* True when the press is inside the page's main game section (a section of <main> that holds the game area): start buttons and overlays included; header, nav, footer, back link and text-only sections are not. */
function inGame(t){
  if(!t||!t.closest)return false;
  if(t.closest('.plh-m'))return true; /* the "How to play" overlay (pl-tutorial.js) is added to <body>, but belongs to the game */
  var mn=t.closest('main,#MainContent,[role="main"]'),s=t.closest('.shopify-section');
  if(!mn||!s||!mn.contains(s))return false;
  return GAME.test(s.id)||!!s.querySelector(AREA);
}
/* Keys that are not play: Escape, Tab and modifier-only keys. */
var NOPLAY={Escape:1,Tab:1,Shift:1,Control:1,Alt:1,AltGraph:1,Meta:1,OS:1,Super:1,Hyper:1,Fn:1,FnLock:1,CapsLock:1,NumLock:1,ScrollLock:1,Symbol:1,SymbolLock:1};
/* True while the privacy panel (#pl-priv) or any visible dialog is open. */
function dlgOpen(){
  try{var q=document.querySelectorAll('#pl-priv,[role=dialog],[role=alertdialog],dialog[open],[aria-modal="true"]');
  for(var i=0;i<q.length;i++){var x=q[i];if(x.hidden)continue;if(x.getClientRects().length&&getComputedStyle(x).visibility!=='hidden')return true}}catch(z){}
  return false;
}
function go(e){
  if(done)return;
  if(e.type==='keydown'&&(NOPLAY[e.key]||dlgOpen()))return;
  if(e.type!=='keydown'&&!inGame(e.target))return;
  done=true;
  ['pointerdown','keydown','touchstart'].forEach(function(n){removeEventListener(n,go,true)});
  try{fetch(URL_,{method:'POST',body:slug,headers:{'Content-Type':'text/plain'},keepalive:true,credentials:'omit',referrerPolicy:'no-referrer',mode:'cors',cache:'no-store'}).catch(function(){})}catch(x){}
}
['pointerdown','keydown','touchstart'].forEach(function(n){addEventListener(n,go,{capture:true,passive:true})});
})();
